var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"backStore"},[_c('pre',[_vm._v("    "+_vm._s(_vm.store)+"\n  ")]),_c('button',{on:{"click":_vm.getStore}},[_vm._v("Get Store")]),_c('button',{on:{"click":_vm.clearStore}},[_vm._v("Clear Store")])])}
var staticRenderFns = []

export { render, staticRenderFns }